var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-button',{on:{"click":_vm.goToPage}},[_vm._v("新tab打開頁面")])
}
var staticRenderFns = []

export { render, staticRenderFns }